import React, { useEffect, useState } from 'react';
import { AlertTriangle, CreditCard } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import api from '../lib/api';

/**
 * Banner exibido no topo do CRM quando a assinatura do tenant está vencida
 * ou próxima do vencimento. Só aparece para usuários com role 'master'.
 */
const VencimentoBanner = () => {
  const { user } = useAuth();
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user || (user.role !== 'master' && user.cargo !== 'master')) return;

    const fetchStatus = async () => {
      try {
        const res = await api.get('/subscription/status');
        setInfo(res.data);
      } catch (e) {
        // silencioso
      }
    };
    fetchStatus();
  }, [user]);

  if (!user || (user.role !== 'master' && user.cargo !== 'master')) return null;
  if (!info || dismissed) return null;

  const status = info.status;
  const periodEnd = info.current_period_end ? new Date(info.current_period_end) : null;
  const now = new Date();
  const diasRestantes = periodEnd ? Math.ceil((periodEnd - now) / (1000 * 60 * 60 * 24)) : null;

  // Definir mensagem por prioridade
  let bgColor = '';
  let icon = null;
  let titulo = '';
  let descricao = '';

  if (status === 'suspended') {
    bgColor = 'bg-red-600 text-white';
    icon = <AlertTriangle className="w-5 h-5" />;
    titulo = 'Assinatura suspensa';
    descricao = 'Regularize o pagamento para continuar usando o sistema.';
  } else if (status === 'past_due') {
    bgColor = 'bg-orange-500 text-white';
    icon = <AlertTriangle className="w-5 h-5" />;
    titulo = 'Pagamento em atraso';
    const atraso = diasRestantes !== null ? Math.abs(diasRestantes) : 0;
    const carencia = info.dias_suspensao ?? 5;
    descricao = `Sua assinatura venceu há ${atraso} dia(s). Após ${carencia} dias o acesso será suspenso.`;
  } else if (status === 'active' && diasRestantes !== null && diasRestantes >= 0 && diasRestantes <= 5 && info.dia_vencimento) {
    bgColor = 'bg-amber-100 text-amber-900 border-b border-amber-300';
    icon = <CreditCard className="w-5 h-5" />;
    titulo = 'Vencimento próximo';
    descricao = diasRestantes === 0
      ? 'Sua mensalidade vence hoje.'
      : `Sua mensalidade vence em ${diasRestantes} dia(s).`;
  } else {
    return null;
  }

  return (
    <div
      data-testid="vencimento-banner"
      className={`w-full px-4 py-2 flex items-center justify-between gap-3 ${bgColor}`}
    >
      <div className="flex items-center gap-2 text-sm">
        {icon}
        <span className="font-semibold">{titulo}:</span>
        <span>{descricao}</span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="text-xs opacity-80 hover:opacity-100 underline"
        data-testid="vencimento-banner-close"
      >
        Fechar
      </button>
    </div>
  );
};

export default VencimentoBanner;
